import { apiSlice } from "./apiSlice";

export const classApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAllClasses: builder.query({
			query: () => "/Class",
			providesTags: ["Classes"],
		}),

		getClassByDepartment: builder.query({
			query: (departmentId) => `/Class/by-department/${departmentId}`,
			providesTags: (result, error, departmentId) => [
				{ type: "Classes", id: departmentId },
			],
		}),

		getClassById: builder.query({
			query: (id) => `/Class/${id}`,
			providesTags: (result, error, id) => [{ type: "Classes", id }],
		}),

		createClass: builder.mutation({
			query: (classData) => {
				console.log("API: Creating class with data:", classData);
				return {
					url: "/Class",
					method: "POST",
					body: classData,
				};
			},
			invalidatesTags: ["Classes"],
		}),

		updateClass: builder.mutation({
			query: ({ id, ...classData }) => ({
				url: `/Class/${id}`,
				method: "PUT", 
				body: classData,
			}),
			invalidatesTags: (result, error, { id }) => [
				"Classes",
				{ type: "Classes", id },
			],
		}),

		deleteClass: builder.mutation({
			query: (id) => ({
				url: `/Class/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["Classes"],
		}),
	}),
});

export const {
	useGetAllClassesQuery,
	useGetClassByDepartmentQuery,
	useGetClassByIdQuery,
	useCreateClassMutation,
	useUpdateClassMutation,
	useDeleteClassMutation,
} = classApiSlice;